/* Copy do shell: navegação, cabeçalho utilitário e o seletor de idioma. É a moldura que aparece
   em toda rota autenticada — e a primeira prova visível de que a troca de idioma funciona. */
import type { Bilingual } from '../bilingual.js';

export interface ShellContent {
  readonly searchPlaceholder: string;
  readonly searchLabel: string;
  readonly languageLabel: string;
  /** Nome de cada idioma NO PRÓPRIO idioma — quem procura "English" não lê "Inglês". */
  readonly languageNames: Readonly<Record<'pt-BR' | 'en-US', string>>;
  readonly themeLabel: string;
  readonly userMenuLabel: string;
  readonly signOut: string;
}

export const SHELL_CONTENT: Bilingual<ShellContent> = {
  'pt-BR': {
    searchPlaceholder: 'Buscar…',
    searchLabel: 'Buscar no backoffice',
    languageLabel: 'Idioma',
    languageNames: { 'pt-BR': 'Português (Brasil)', 'en-US': 'English (US)' },
    themeLabel: 'Tema',
    userMenuLabel: 'Menu do operador',
    signOut: 'Sair',
  },
  'en-US': {
    searchPlaceholder: 'Search…',
    searchLabel: 'Search the backoffice',
    languageLabel: 'Language',
    languageNames: { 'pt-BR': 'Português (Brasil)', 'en-US': 'English (US)' },
    themeLabel: 'Theme',
    userMenuLabel: 'Operator menu',
    signOut: 'Sign out',
  },
};
